import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import {
  PermissionAction,
  PermissionScreenNode,
} from '@app/features/dashboard/group-register/permission-tree/permission-tree.models';
import { SearchResultScreen } from '@app/features/dashboard/group-register/permission-tree/permission-selection.utils';
import { PermissionActionRowComponent } from '@app/features/dashboard/group-register/components/permission-action-row/permission-action-row.component';
import { PermissionValueChange } from '@app/features/dashboard/group-register/components/permission-screen-panel/permission-screen-panel.component';

/** Resultados da busca, juntando as ações de todas as telas, cada uma com o caminho no menu. */
@Component({
  selector: 'app-permission-search-results',
  standalone: true,
  imports: [SharedModule, PermissionActionRowComponent],
  templateUrl: './permission-search-results.component.html',
  styleUrls: ['./permission-search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermissionSearchResultsComponent {
  readonly query = input.required<string>();
  readonly results = input.required<SearchResultScreen[]>();
  readonly selected = input.required<ReadonlySet<string>>();
  readonly initial = input<ReadonlySet<string>>(new Set());

  readonly valueChange = output<PermissionValueChange>();
  readonly bulkChange = output<{ values: string[]; checked: boolean }>();
  readonly screenOpen = output<PermissionScreenNode>();
  readonly clearSearch = output<void>();

  readonly values = computed(() =>
    this.results().flatMap(result => result.actions.map(action => action.value))
  );

  readonly selectedCount = computed(
    () => this.values().filter(value => this.selected().has(value)).length
  );

  readonly screenCount = computed(() => this.results().length);

  isChecked(action: PermissionAction): boolean {
    return this.selected().has(action.value);
  }

  isChanged(action: PermissionAction): boolean {
    return this.selected().has(action.value) !== this.initial().has(action.value);
  }

  setAll(checked: boolean): void {
    this.bulkChange.emit({ values: this.values(), checked });
  }
}
